export type AlphaDetailsSummary = {
  is: {
    summary: {
      id: string;
      type: string;
      title: string;
    }[];
    performance: {
      id: string;
      type: string;
      title: string;
    }[];
  };
  os: {
    summary: {
      id: string;
      type: string;
      title: string;
    }[];
    performance: {
      id: string;
      type: string;
      title: string;
    }[];
  };
  prod: {
    summary: {
      id: string;
      type: string;
      title: string;
    }[];
    performance: {
      id: string;
      type: string;
      title: string;
    }[];
  };
};

export const AlphaDetailsSummaryColumns: any = {
  train: {
    summary: [
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
        alphaPath: ['is', 'sharpe'],
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
        alphaPath: ['is', 'turnover'],
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
        alphaPath: ['is', 'fitness'],
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
        alphaPath: ['is', 'returns'],
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
        alphaPath: ['is', 'drawdown'],
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
        alphaPath: ['is', 'margin'],
      },
    ],
    performance: [
      {
        id: 'year',
        type: 'year',
        title: 'alphaSummary.year',
      },
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
      {
        id: 'longCount',
        type: 'integer',
        title: 'alphaSummary.longCount',
      },
      {
        id: 'shortCount',
        type: 'integer',
        title: 'alphaSummary.shortCount',
      },
      {
        id: 'stage',
        type: 'string',
        title: 'alphaSummary.stage',
      },
    ],
  },
  test: {
    summary: [
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
        alphaPath: ['is', 'sharpe'],
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
        alphaPath: ['is', 'turnover'],
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
        alphaPath: ['is', 'fitness'],
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
        alphaPath: ['is', 'returns'],
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
        alphaPath: ['is', 'drawdown'],
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
        alphaPath: ['is', 'margin'],
      },
    ],
    performance: [
      {
        id: 'year',
        type: 'year',
        title: 'alphaSummary.year',
      },
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
      {
        id: 'longCount',
        type: 'integer',
        title: 'alphaSummary.longCount',
      },
      {
        id: 'shortCount',
        type: 'integer',
        title: 'alphaSummary.shortCount',
      },
      {
        id: 'stage',
        type: 'string',
        title: 'alphaSummary.stage',
      },
    ],
  },
  is: {
    summary: [
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
        alphaPath: ['is', 'sharpe'],
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
        alphaPath: ['is', 'turnover'],
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
        alphaPath: ['is', 'fitness'],
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
        alphaPath: ['is', 'returns'],
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
        alphaPath: ['is', 'drawdown'],
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
        alphaPath: ['is', 'margin'],
      },
    ],
    performance: [
      {
        id: 'year',
        type: 'year',
        title: 'alphaSummary.year',
      },
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
      {
        id: 'longCount',
        type: 'integer',
        title: 'alphaSummary.longCount',
      },
      {
        id: 'shortCount',
        type: 'integer',
        title: 'alphaSummary.shortCount',
      },
      {
        id: 'stage',
        type: 'string',
        title: 'alphaSummary.stage',
      },
    ],
  },
  os: {
    summary: [
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
    ],
    performance: [
      {
        id: 'sharpe60',
        type: 'decimal',
        title: 'alphaSummary.sharpe60',
      },
      {
        id: 'sharpe125',
        type: 'decimal',
        title: 'alphaSummary.sharpe125',
      },
      {
        id: 'sharpe250',
        type: 'decimal',
        title: 'alphaSummary.sharpe250',
      },
      {
        id: 'sharpe500',
        type: 'decimal',
        title: 'alphaSummary.sharpe500',
      },
      {
        id: 'osISSharpeRatio',
        type: 'decimal',
        title: 'alphaSummary.osISSharpeRatio',
      },
      {
        id: 'preCloseSharpe',
        type: 'decimal',
        title: 'alphaSummary.preCloseSharpe',
      },
      {
        id: 'preCloseSharpeRatio',
        type: 'decimal',
        title: 'alphaSummary.preCloseSharpeRatio',
      },
      {
        id: 'selfCorrelation',
        type: 'decimal',
        title: 'alphaSummary.selfCorrelation',
      },
    ],
  },
  prod: {
    summary: [
      {
        id: 'sharpe',
        type: 'decimal',
        title: 'alphaSummary.sharpe',
      },
      {
        id: 'turnover',
        type: 'percent',
        title: 'alphaSummary.turnover',
      },
      {
        id: 'fitness',
        type: 'decimal',
        title: 'alphaSummary.fitness',
      },
      {
        id: 'returns',
        type: 'percent',
        title: 'alphaSummary.returns',
      },
      {
        id: 'drawdown',
        type: 'percent',
        title: 'alphaSummary.drawdown',
      },
      {
        id: 'margin',
        type: 'permyriad',
        title: 'alphaSummary.margin',
      },
    ],
    performance: [
      {
        id: 'birthDate',
        type: 'date',
        title: 'alphaSummary.birthDate',
      },
      {
        id: 'osISSharpeRatio',
        type: 'decimal',
        title: 'alphaSummary.osISSharpeRatio',
      },
      {
        id: 'preCloseSharpe',
        type: 'decimal',
        title: 'alphaSummary.preCloseSharpe',
      },
      {
        id: 'preCloseSharpeRatio',
        type: 'decimal',
        title: 'alphaSummary.preCloseSharpeRatio',
      },
      {
        id: 'selfCorrelation',
        type: 'decimal',
        title: 'alphaSummary.selfCorrelation',
      },
      {
        id: 'prodCorrelation',
        type: 'decimal',
        title: 'alphaSummary.prodCorrelation',
      },
    ],
  },
};

// Alphas Self Correlation Columns
export const alphaColumnsSelfCorrelation = [
  { id: 'name', type: 'string', title: 'alphaSummary.name', alphaPath: ['name'] },
  { id: 'universe', type: 'string', title: 'alphaSummary.universe', alphaPath: ['settings', 'universe'] },
  { id: 'correlation', type: 'number', title: 'alphaSummary.correlation' },
].concat(AlphaDetailsSummaryColumns.is.summary);

// Alphas Selected Alphas Columns
export const alphaColumnsSelectedAlphas = [
  { id: 'name', type: 'string', title: 'alphaSummary.name', alphaPath: ['name'] },
  { id: 'universe', type: 'string', title: 'alphaSummary.universe', alphaPath: ['settings', 'universe'] },
].concat(AlphaDetailsSummaryColumns.is.summary);
